const style = require("../../../../../components/report/report-style");
const css = style.get();

// Helpers
const formatCurrency = (value) => value.toLocaleString("en-US", { style: "currency", currency: "USD" });
const parseAmount = (val) => parseFloat(String(val || "0").replace(/[$,]/g, "")) || 0;
const getRowClass = (i) => (i % 2 === 0 ? "" : css.trGray);

// Configuración para separar la lógica de Pagar vs Cobrar
const REPORT_CONFIG = {
  payable: {
    cssClass: "accountsPayable-dataCont",
    entityName: "Provider",
    entityKey: "provider",
    idKey: "provider_id",
    reportType: "accountPayable",
    description: "Providers Vs Aging Owed Amounts: This is a financial document that provides information about money owed by a company to its vendors or providers for goods or services purchased on credit."
  },
  receivable: {
    cssClass: "accountsReceivable-dataCont",
    entityName: "Customer",
    entityKey: "customer",
    idKey: "customer_id",
    reportType: "accountReceivable",
    description: "Customers Vs Aging Owed Amounts: This is a financial document that provides information about money owed to a company by its customers or clients for goods or services provided on credit."
  }
};

// Generador Maestro Único
function buildAgingReport(data, type) {
  if (!data?.length) return "";
  
  const conf = REPORT_CONFIG[type];
  const head = data[0];
  const entityLabel = head[conf.entityKey] ?? "All";

  let html = `
    <div class="dataCont ${conf.cssClass} dn">
      <div ${css.title}>${head.company_name}</div>
      <div ${css.subtitle}>${entityLabel} Account ${type === 'payable' ? 'Payable' : 'Receivable'} Aging Report As Of ${head.current_dateTime}</div>
      <h2 ${css.f15}>${conf.description}</h2>
      <table ${css.table} class="dt-alterColor">
        <tr>
          <th ${css.th}>${conf.entityName}</th>
          <th ${css.th}>Current</th>
          <th ${css.th}>30 days</th>
          <th ${css.th}>31 to 60 days</th>
          <th ${css.th}>61 to 90 days</th>
          <th ${css.th}>Over 90 days</th>
          <th ${css.th}>Total</th>   
        </tr>
  `;

  const totals = { current: 0, d30: 0, d60: 0, d90: 0, over90: 0, grandTotal: 0 };

  // Iteración de filas y cálculos
  data.forEach((row, i) => {
    const current = parseAmount(row.current);
    const d30 = parseAmount(row.total_due_30_days);
    const d60 = parseAmount(row.total_due_31_to_60_days);
    const d90 = parseAmount(row.total_due_61_to_90_days);
    const over90 = parseAmount(row.total_due_over_90_days);
    const rowTotal = current + d30 + d60 + d90 + over90;

    totals.current += current;
    totals.d30 += d30;
    totals.d60 += d60;
    totals.d90 += d90;
    totals.over90 += over90;
    totals.grandTotal += rowTotal;

    const detailHtml = `data-detail='{"click": [{"dest":"ripple"}, {"dest":"${conf.entityKey}", "elem":"report", "reportType":"${conf.reportType}", "entity":"${conf.entityKey}", "dbid":"${row[conf.idKey]}", "source":"dt"}]}'`;

    html += `
        <tr ${getRowClass(i)}>
          <td class='tdClick' ${css.td} ${detailHtml}>${row[conf.entityKey]}</td>
          <td ${css.td}>${row.current}</td>
          <td ${css.td}>${row.total_due_30_days}</td>
          <td ${css.td}>${row.total_due_31_to_60_days}</td>
          <td ${css.td}>${row.total_due_61_to_90_days}</td>
          <td ${css.td}>${row.total_due_over_90_days}</td>
          <td ${css.td}>${formatCurrency(rowTotal)}</td>
        </tr>
    `;
  });

  // Fila de Totales
  html += `
        <tr ${getRowClass(data.length)}>
          <td ${css.totalLabel}>Total</td>
          <td ${css.totalCell}>${formatCurrency(totals.current)}</td>
          <td ${css.totalCell}>${formatCurrency(totals.d30)}</td>
          <td ${css.totalCell}>${formatCurrency(totals.d60)}</td>
          <td ${css.totalCell}>${formatCurrency(totals.d90)}</td>
          <td ${css.totalCell}>${formatCurrency(totals.over90)}</td>
          <td ${css.totalCell}>${formatCurrency(totals.grandTotal)}</td>
        </tr> 
      </table>
    </div> <div class="report-page"></div>
  `;

  return html;
}

// Exportamos las funciones exactas que el resto de tu app está esperando
export const generatePayableAll = (data) => buildAgingReport(data, "payable");
export const generateReceivableAll = (data) => buildAgingReport(data, "receivable");